import styled from "styled-components";

export const Container = styled.div `

    display: flex;
    flex-direction: column;
    align-items: center;

    .div-photos-person {
        display: grid;
        gap: 10px;
        grid-template-columns: ${props => props?.maximized ? "repeat(8, 1fr)" : "repeat(6, 1fr)"};
    }

    .content-photo-person {
        position: relative;
        color: #fff;
        background: unset;
        border: none;
        border-radius: 5px;
    }

    .content-photo-person img {
        width: 100%;
        border-radius: 5px;
        background: #222222;
    }

    .span-curtidas {
        position: absolute;
        bottom: 10px;
        left: 5px;
        display: flex;
        align-items: center;
        background: #252525;
        border-radius: 50px;
        padding: 5px 10px;
        font-size: .9rem;
        font-weight: bold;
        border: .1px solid #aaa;
        cursor: default;
    }

    .span-curtidas i {
        margin-right: 5px;
    }

    .section-bt-more button {
        background: #404040;
        border: none;
        border-radius: 50px;
        color: #fff;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 700;
        padding: 10px 40px;
        margin: 50px 0;
        transition: all .3s ease;
    }

    .section-bt-more button:hover {
        background: #505050;
    }

    @media (max-width: 1600px) {

        .div-photos-person {
            grid-template-columns: ${props => props?.maximized ? "repeat(7, 1fr)" : "repeat(5, 1fr)"};
        }

        .span-curtidas {
            font-size: .7rem;
        }

    }

    @media (max-width: 1200px) {

        .div-photos-person {
            grid-template-columns: ${props => props?.maximized ? "repeat(6, 1fr)" : "repeat(5, 1fr)"};
        }

    }

    @media (max-width: 1000px) {

        .div-photos-person {
            grid-template-columns: ${props => props?.maximized ? "repeat(5, 1fr)" : "repeat(5, 1fr)"};
        }

    }

    @media (max-width: 800px) {

        .div-photos-person {
            grid-template-columns: repeat(4, 1fr);
        }

    }

    @media (max-width: 500px) {

        .div-photos-person {
            grid-template-columns: repeat(3, 1fr);
        }

    }

    @media (max-width: 350px) {

        .div-photos-person {
            grid-template-columns: repeat(2, 1fr);
        }

    }

`